import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { StationOnlineStatus } from '~types/station.type';

type ReqParams = {
  box: string;
};

export const useQueryGetStationStatusByImeiOrSerial = (
  reqParams: ReqParams,
  options?: Omit<
    UseQueryOptions<
      StationOnlineStatus,
      AxiosError<Record<string, string>>,
      StationOnlineStatus,
      (QUERY_KEY | string)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const getSetting = (): Promise<StationOnlineStatus> =>
    getRequest({
      path: 'api/station/online-status',
      params: reqParams,
    });

  return useQuery(
    [QUERY_KEY.GET_STATION_STATUS_BY_IMEI_OR_SERIAL, reqParams.box],
    () => getSetting(),
    {
      ...options,
    },
  );
};
